var map = {
	"./1_19-_DSC9505-2.webp": 876,
	"./2_55-_DSC8958-3.webp": 877,
	"./3_DSC_6868.webp": 878,
	"./4_DSC_7227.webp": 879,
	"./5_DSC_7559-3.webp": 880,
	"./6_DSC_8116-2.webp": 881,
	"./7_DSC_8390.webp": 882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;